import React from 'react'
import './navbar.css'
import logo from './Logo.png'
import { Link } from 'react-scroll'
import Headroom from 'react-headroom'
import Curve from '../Custom/Curve'

const Navbar = () => {
	return (
		<Headroom style={{zIndex: 3}}>
			<nav className='navbar'>
				<img src={logo} alt="logo" className='h-[65px]' />
				<ul className='navList'>
					<li className='tags'><Link className='navLink' to="home" spy={true} smooth={true} offset={-100} duration={500}>Home</Link></li>
					<li className='tags'><Link className='navLink' to="about" spy={true} smooth={true} offset={-150} duration={500}>About</Link></li>
					<li className='tags'><Link className='navLink' to="proj" spy={true} smooth={true} offset={-100} duration={500}>Projects</Link></li>
					<li className='tags'><Link className='navLink' to="ach" spy={true} smooth={true} offset={0} duration={500}>Achievements</Link></li>
					<li className='tags'><Link className='navLink' to="contact" spy={true} smooth={true} offset={-10} duration={500}>Contact me</Link></li>
				</ul>
				<Curve/>
			</nav>
		</Headroom>
	)
}

export default Navbar